<div class="wd-multiselect" [class.wd-open]="isOpen">
  <div class="wd-dropdown-btn" (click)="toggleDropdown()">
    <div class="wd-selected-container">
      <span *ngIf="selectedItems.length === 0" class="wd-placeholder">{{ placeholder }}</span>
      <div *ngFor="let item of selectedItems" class="wd-chip">
        <span>{{ item[textField] }}</span>
        <button type="button" class="wd-remove-chip" (click)="removeItem(item, $event)">&times;</button>
      </div>
    </div>
    <span class="wd-arrow" [class.wd-arrow-up]="isOpen"></span>
  </div>

  <div class="wd-dropdown-list" *ngIf="isOpen">
    <div class="wd-search-wrapper" *ngIf="allowSearchFilter">
      <input 
        #searchInput
        type="text" 
        class="wd-search-input" 
        [placeholder]="'Cerca...'"
        [value]="searchText"
        (input)="handleSearchInput($event)"
        (click)="$event.stopPropagation()"
      >
    </div>
    <ul class="wd-list-items">
      <li *ngFor="let item of filteredData" (click)="toggleItem(item)" [class.wd-selected-item]="isSelected(item)">
        <div class="wd-checkbox" [class.wd-checked]="isSelected(item)"></div>
        <span class="wd-item-text">{{ item[textField] }}</span>
      </li>
      <li *ngIf="filteredData.length === 0" class="wd-no-data">
        Nessun risultato
      </li>
    </ul>
  </div>
</div>
